import React from "react";

interface VerticalArrowsProps {
  count?: number;
  height?: number;
  className?: string;
}

const VerticalArrows: React.FC<VerticalArrowsProps> = ({
  count = 1,
  height = 110,
  className = "",
}) => {
  return (
    <div className={`flex gap-2 items-center ${className}`}>
      {Array.from({ length: count }).map((_, index) => {
        const gradientId = `arrow-gradient-${index}`;

        return (
          <svg
            key={index}
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height={height}
            viewBox="0 0 16 110"
            fill="none"
          >
            <path
              d="M16 101.5C16 97.0817 12.4183 93.5 8 93.5C3.58172 93.5 0 97.0817 0 101.5C0 105.918 3.58172 109.5 8 109.5C12.4183 109.5 16 105.918 16 101.5ZM9.5 1.5V0H6.5V1.5H9.5ZM8 101.5H9.5L9.5 1.5H8H6.5L6.5 101.5H8Z"
              fill={`url(#${gradientId})`}
            />

            <defs>
              <linearGradient
                id={gradientId}
                x1="8"
                y1="0"
                x2="8"
                y2="110"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0%" stopColor="#DFDFDF">
                  <animate
                    attributeName="offset"
                    values="-1;1"
                    dur="2s"
                    repeatCount="indefinite"
                  />
                </stop>

                <stop offset="50%" stopColor="#2D65F2">
                  <animate
                    attributeName="offset"
                    values="0;2"
                    dur="2s"
                    repeatCount="indefinite"
                  />
                </stop>

                <stop offset="100%" stopColor="#FFFFFF">
                  <animate
                    attributeName="offset"
                    values="1;3"
                    dur="2s"
                    repeatCount="indefinite"
                  />
                </stop>
              </linearGradient>
            </defs>
          </svg>
        );
      })}
    </div>
  );
};

export default VerticalArrows;
